import { actions } from 'react-table';
import { TOGGLE_USER_SETTING_POPUP, SET_USER_SETTING_ACTIVE_TAB } from '../constants/actionTypes';

const INITIAL_STATE = { userSettingPopUp: false, userSettingActiveTab: 0}

export default function userSetting(state = INITIAL_STATE, action) {
  switch (action.type) {
    case TOGGLE_USER_SETTING_POPUP:
      return { ...state, userSettingPopUp: !state.userSettingPopUp }
    case SET_USER_SETTING_ACTIVE_TAB:
      return { ...state, userSettingActiveTab: action.payload }
    default:
      return state;
  }
}